import SocketContext, { SocketRef, SocketListener } from "./context";

const SocketManager = {
  Portal: () => <SocketContext ref={SocketRef} />,
  subscribe: (topic: string, listener: SocketListener) => {
    SocketRef.current!.subscribe(topic, listener);
  },
  connectStaffSocket: (staffId: string | number) => {
    SocketRef.current!.connectStaffSocket(staffId);
  },
};

export default SocketManager;
